import {Component, HostListener, OnInit, Output} from '@angular/core';
import {ApiClientService} from '../../../../services/api-client.service';
import {PropertyService} from '../services/property.service';
import {Router, ActivatedRoute} from '@angular/router';
import {ConstantsService} from '../../../../services/constants.service';
import {Observable} from 'rxjs/Observable';
import {concatMap} from 'rxjs/operators';
import {UrlService} from '../../../../services/url.service';
import {BuildingSetupAmenity} from '../../../../types/data.types';

declare const swal: any;
declare const toastr: any;
declare const $: any;

@Component({
    templateUrl: './building-setup.component.html',
    styleUrls: ['./building-setup.component.scss']
})
export class BuildingSetupComponent implements OnInit {

    step = '1';
    managementServices: Array<any> = [
        {name: 'bldn', displayName: 'Building Directory', checked: false},
        {name: 'email_merge', displayName: 'Email Merge', checked: false},
        {name: 'service_request', displayName: 'Service Request', checked: false},
        {name: 'documents', displayName: 'Documents', checked: false},
        {name: 'amenity', displayName: 'Amenity', checked: false},
        {name: 'parking_pass', displayName: 'Parking Pass', checked: false},
    ];
    securityServices: Array<any> = [
        {name: 'parcels', displayName: 'Parcels', checked: false},
        {name: 'pass_on_log', displayName: 'Pass On Log', checked: false},
        {name: 'inc_report', displayName: 'Incident Report', checked: false},
        {name: 'daily_report', displayName: 'Daily Report', checked: false},
        {name: 'key_log', displayName: 'Key Log', checked: false},
        {name: 'report_builder', displayName: 'Report Builder', checked: false},
    ];
    amenitiesList: Array<any> = [
        new BuildingSetupAmenity('1', 'BBQs', 'bbq.svg'),
        new BuildingSetupAmenity('2', 'Conference room', 'tv_room.svg'),
        new BuildingSetupAmenity('3', 'Elevator', 'elevator.svg'),
        new BuildingSetupAmenity('4', 'Guest Suite', 'guestsuite.svg'),
        new BuildingSetupAmenity('5', 'Gym', 'fitness.svg'),
        new BuildingSetupAmenity('6', 'Kids Room', 'kids_room.svg'),
        new BuildingSetupAmenity('7', 'Media Room', 'mediaroom.svg'),
        new BuildingSetupAmenity('8', 'Meeting Room', 'meeting_room.svg'),
        new BuildingSetupAmenity('9', 'Party Room', 'party_room.svg'),
        new BuildingSetupAmenity('10', 'Pool', 'swimingpool_indoor.svg'),
        new BuildingSetupAmenity('11', 'Sauna', 'saunas.svg'),
        new BuildingSetupAmenity('12', 'Spa', 'spa.svg')
    ];
    timeIntervals = [
        {name: 'min', displayName: 'Minute'},
        {name: 'hour', displayName: 'Hour'},
        {name: 'day', displayName: 'Day'},
        {name: 'week', displayName: 'Week'},
        {name: 'month', displayName: 'Month'},
        {name: 'year', displayName: 'Year'}
    ];
    timings: Array<any> = [
        {value: '00:00', displayedValue: '12:00 AM'},
        {value: '00:30', displayedValue: '12:30 AM'},
        {value: '01:00', displayedValue: '01:00 AM'},
        {value: '01:30', displayedValue: '01:30 AM'},
        {value: '02:00', displayedValue: '02:00 AM'},
        {value: '02:30', displayedValue: '02:30 AM'},
        {value: '03:00', displayedValue: '03:00 AM'},
        {value: '03:30', displayedValue: '03:30 AM'},
        {value: '04:00', displayedValue: '04:00 AM'},
        {value: '04:30', displayedValue: '04:30 AM'},
        {value: '05:00', displayedValue: '05:00 AM'},
        {value: '05:30', displayedValue: '05:30 AM'},
        {value: '06:00', displayedValue: '06:00 AM'},
        {value: '06:30', displayedValue: '06:30 AM'},
        {value: '07:00', displayedValue: '07:00 AM'},
        {value: '07:30', displayedValue: '07:30 AM'},
        {value: '08:00', displayedValue: '08:00 AM'},
        {value: '08:30', displayedValue: '08:30 AM'},
        {value: '09:00', displayedValue: '09:00 AM'},
        {value: '09:30', displayedValue: '09:30 AM'},
        {value: '10:00', displayedValue: '10:00 AM'},
        {value: '10:30', displayedValue: '10:30 AM'},
        {value: '11:00', displayedValue: '11:00 AM'},
        {value: '11:30', displayedValue: '11:30 AM'},
        {value: '12:00', displayedValue: '12:00 PM'},
        {value: '12:30', displayedValue: '12:30 PM'},
        {value: '13:00', displayedValue: '01:00 PM'},
        {value: '13:30', displayedValue: '01:30 PM'},
        {value: '14:00', displayedValue: '02:00 PM'},
        {value: '14:30', displayedValue: '02:30 PM'},
        {value: '15:00', displayedValue: '03:00 PM'},
        {value: '15:30', displayedValue: '03:30 PM'},
        {value: '16:00', displayedValue: '04:00 PM'},
        {value: '16:30', displayedValue: '04:30 PM'},
        {value: '17:00', displayedValue: '05:00 PM'},
        {value: '17:30', displayedValue: '05:30 PM'},
        {value: '18:00', displayedValue: '06:00 PM'},
        {value: '18:30', displayedValue: '06:30 PM'},
        {value: '19:00', displayedValue: '07:00 PM'},
        {value: '19:30', displayedValue: '07:30 PM'},
        {value: '20:00', displayedValue: '08:00 PM'},
        {value: '20:30', displayedValue: '08:30 PM'},
        {value: '21:00', displayedValue: '09:00 PM'},
        {value: '21:30', displayedValue: '09:30 PM'},
        {value: '22:00', displayedValue: '10:00 PM'},
        {value: '22:30', displayedValue: '10:30 PM'},
        {value: '23:00', displayedValue: '11:00 PM'},
        {value: '23:30', displayedValue: '11:30 PM'},
    ];
    currentProgress = 0;
    selectedAmenity = null;
    // useStandartTermsAndAgreement = true;
    useStandartTermsAndAgreementForParkingPass = true;
    amenityTermsPdfSrc: string = '';
    pdfPage = 1;
    currentPdfMaxPage = 1;
    fileIsOver = false;
    hasVisitorParking = false;
    requireVisitorsToRegister = false;
    parkingPassRules = [
        {name: 'day', checked: false, displayName: 'Day Pass', from: '', to: ''},
        {name: 'night', checked: false, displayName: 'Night Pass', from: '', to: ''},
        {name: '24', checked: false, displayName: '24 Hour Pass', from: '', to: ''},
    ];
    parkingPassLimitations = {
        limited: false,
        number: null,
    };
    // parkingPassTerms = '';
    parkingPassCustomTerms = '';
    // parkingPassAgreement = '';
    parkingTermsPdfSrc: string = '';
    receiveParcelsOnBehalf = false;
    requireToSignParcelsWaiver = false;
    useBarCodeScanner = false;
    useSignaturePad = false;
    previousButtonIsDisabled = false;
    nextButtonIsDisabled = false;
    userRoles = [];
    selectedBuildingId;
    selectedBuilding = null;
    buildingsList = [];
    serviceUpdateId;
    @Output() public options = {
        readAs: 'DataURL'
    };

    constructor(public api: ApiClientService,
                private router: Router,
                private route: ActivatedRoute,
                public urlService: UrlService,
                public propertyService: PropertyService) {}

    ngOnInit() {
        this.selectedBuildingId = this.route.snapshot.url[1].path;
        this.initData();
    }

    initData() {
        if(this.propertyService.currentServices) {
            this.managementServices.forEach(s => {
                s.checked = this.propertyService.currentServices.serviceIdentifier.indexOf(s.name) != -1;
            });
            this.securityServices.forEach(s => {
                s.checked = this.propertyService.currentServices.serviceIdentifier.indexOf(s.name) != -1;
            });
        }
        this.getBuildingServices();
        this.getBuildingInfo();
        this.getUserRoles();
        this.getBuildings();
    }

    goBack() {
        const checkedAmenities = this.amenitiesList.filter(amenity => amenity.checked);
        const bookableAmenities = this.amenitiesList.filter(amenity => amenity.checked && amenity.bookable);
        if(this.step != '1') {
            if(this.step == '13') {
                // if (this.useStandartTermsAndAgreement)
                    this.showLegalAgreementEditPanelSetter();
                this.step = '12';
            } else if(this.step == '11') {
                this.step = this.selectedAmenity.paymentDetails.hasPayments ? '10' : '9';
            } else if(this.step == '14') {
                if (!this.managementServices[4].checked)
                    this.step = '1';
                else if (this.managementServices[4].checked && bookableAmenities.length > 0)
                    this.step = '5';
                else
                    this.step = '2';
            } else if(this.step == '20') {
                if(this.requireVisitorsToRegister) {
                    // if(this.useStandartTermsAndAgreement)
                        this.showLegalAgreementEditPanelSetter();
                    this.step = '19';
                } else
                    this.step = '15';
            } else if(this.step == '21') {
                if(this.managementServices[5].checked)
                    this.step = '14';
                else if(this.managementServices[4].checked)
                    this.step = '2';
                else
                    this.step = '1';
            } else if(this.step == '23') {
                this.step = '21';
            } else if(this.step == '26') {
                if(this.securityServices[0].checked)
                    this.step = '21';
                else if(this.managementServices[5].checked)
                    this.step = '14';
                else if(this.managementServices[4].checked)
                    this.step = '2';
                else
                    this.step = '1';
            } else
                this.step = (parseInt(this.step) - 1).toString();
        } else
            this.router.navigateByUrl('/property');
    }

    nextStep() {
        const checkedAmenities = this.amenitiesList.filter(amenity => amenity.checked);
        const bookableAmenities = this.amenitiesList.filter(amenity => amenity.checked && amenity.bookable);
        if(this.step == '1') {
            if(this.managementServices[4].checked)
                this.step = '2';
            else if(this.managementServices[5].checked)
                this.step = '14';
            else if(this.securityServices[0].checked)
                this.step = '21';
            else
                this.step = '26';
        } else if(this.step == '2') {
            if(checkedAmenities.length < 1) {
                swal(ConstantsService.getSwalConfig('You haven\'t selected any amenities.', 'Are you sure you don\'t want to setup any?'),
                    () => {
                        this.managementServices[4].checked = false;
                        if(this.managementServices[5].checked)
                            this.step = '14';
                        else if(this.securityServices[0].checked)
                            this.step = '21';
                        else
                            this.step = '26';
                    }
                );
            } else
                this.step = '3';
        } else if(this.step == '4') {
            this.selectedAmenity = bookableAmenities[0];
            if(bookableAmenities.length > 0)
                this.step = '5';
            else if(this.managementServices[5].checked)
                this.step = '14';
            else if(this.securityServices[0].checked)
                this.step = '21';
            else
                this.step = '26';
        } else if(parseInt(this.step) > 4 && parseInt(this.step) < 14) {
            if(this.step == '5') {
                if(!bookableAmenities.find(a => a.name == this.selectedAmenity.name))
                    this.selectedAmenity = bookableAmenities[0];
                if(!this.timingDetailsAreValid()) {
                    toastr.warning('Please, fill all time details.');
                    return;
                }
                if(!this.timingsOverlap()) {
                    this.step = (parseInt(this.step) + 1).toString();
                    this.currentProgress = 25;
                } else
                    toastr.warning('Timings must not overlap.');
            } else if(this.step == '9') {
                if (this.selectedAmenity.paymentDetails.hasPayments) {
                    let paymentsHaveEmptyRequiredvalues = false;
                    this.selectedAmenity.paymentDetails.payments.forEach(fee => {
                        if (!fee.name || !fee.amount)
                            paymentsHaveEmptyRequiredvalues = true;
                    });
                    if (!paymentsHaveEmptyRequiredvalues)
                        this.step = '10';
                    else
                        toastr.warning('Please fill all payment details');
                } else
                    this.step = '11';
            } else if(this.step == '10') {
                if(!this.selectedAmenity.paymentDetails.acceptedPayments.cheque &&
                    !this.selectedAmenity.paymentDetails.acceptedPayments.creditCard)
                    toastr.warning('You must choose at least one payment method.');
                else
                    this.step = '11';
            } else if(this.step == '11') {
                // if(this.useStandartTermsAndAgreement)
                    this.showLegalAgreementEditPanelSetter();
                this.step = (parseInt(this.step) + 1).toString();
            } else if(this.step == '12') {
                this.selectedAmenity.setupCompleted = true;
                const selectedAmenityIndex = bookableAmenities.findIndex(amenity => amenity.name == this.selectedAmenity.name);
                if(selectedAmenityIndex + 1 < bookableAmenities.length) {
                    this.selectedAmenity = bookableAmenities[selectedAmenityIndex + 1];
                    this.step = '5';
                } else
                    this.step = (parseInt(this.step) + 1).toString();
            } else if(this.step == '13') {
                if(this.managementServices[5].checked)
                    this.step = '14';
                else if(this.securityServices[0].checked)
                    this.step = '21';
                else
                    this.step = '26';
            } else
                this.step = (parseInt(this.step) + 1).toString();
        } else if(this.step == '14') {
            if(this.hasVisitorParking)
                this.step = '15';
            else {
                this.step = '21';
                this.managementServices[5].checked = false;
            }
        } else if(this.step == '15') {
            if(this.requireVisitorsToRegister)
                this.step = '16';
            else
                this.step = '20';
        } else if(this.step == '16') {
            if(this.parkingPassRules[0].checked) {
                if(!this.parkingPassRules[0].from || !this.parkingPassRules[0].to) {
                    toastr.warning('Pass times must not be empty.');
                    return;
                }
            }
            if(this.parkingPassRules[1].checked) {
                if(!this.parkingPassRules[1].from || !this.parkingPassRules[1].to) {
                    toastr.warning('Pass times must not be empty.');
                    return;
                }
            }
            if(this.parkingPassRules[0].checked && this.parkingPassRules[1].checked) {
                const dayPassFrom = new Date(`01/01/1970 ${this.parkingPassRules[0].from}`);
                const dayPassTo = new Date(`01/01/1970 ${this.parkingPassRules[0].to}`);
                const nightPassFrom = new Date(`01/01/1970 ${this.parkingPassRules[1].from}`);
                const nightPassTo = new Date(`01/01/1970 ${this.parkingPassRules[1].to}`);
                if(nightPassTo < nightPassFrom)
                    new Date(`01/02/1970 ${this.parkingPassRules[1].to}`);
                if(((dayPassFrom > nightPassFrom) && (dayPassFrom < nightPassTo)) ||
                   ((dayPassTo > nightPassFrom) && (dayPassTo < nightPassTo)) ||
                   ((nightPassFrom > dayPassFrom) && (nightPassFrom < dayPassTo)) ||
                   ((nightPassTo > dayPassFrom) && (nightPassTo < dayPassTo))) {
                    toastr.warning('Pass times must not overlap');
                    return;
                } else
                    this.step = '17';
            } else
                this.step = '17';
        } else if(this.step == '18') {
            // if(this.useStandartTermsAndAgreement)
                this.showLegalAgreementEditPanelSetter();
            this.step = (parseInt(this.step) + 1).toString();
        } else if(this.step == '20') {
            if(this.securityServices[0].checked)
                this.step = '21';
            else
                this.step = '26';
        } else if(this.step == '21') {
            if(this.receiveParcelsOnBehalf)
                this.step = '23';
            else {
                this.step = '26';
                this.securityServices[0].checked = false;
            }
        } else if(this.step == '26') {
            this.setupBuildingServicesWithEnteredInfo();
        } else
            this.step = (parseInt(this.step) + 1).toString();
        this.setProgressBarState();
    }

    showNavigation(): boolean {
        return parseInt(this.step) > 4;
    }

    stepMoreThan(value): boolean {
        return parseInt(this.step) > value;
    }

    stepLessThan(value): boolean {
        return parseInt(this.step) < value;
    }

    selectAmenityFromNavigation(amenity) {
        this.selectedAmenity = amenity;
        this.step = '5';
    }

    addTimeSlot() {
        this.selectedAmenity.timings.push({from: '', to: ''});
    }

    deleteTimeSlot(timeRowIndex): void {
        this.selectedAmenity.timings.splice(timeRowIndex, 1);
    }

    addPayment() {
        this.selectedAmenity.paymentDetails.payments.push({active: 1, required: 1, name: '', amount: '0', refundable: 1, pmtAtTime: 0});
    }

    deletePayment(paymentIndex): void {
        this.selectedAmenity.paymentDetails.payments.splice(paymentIndex, 1);
    }

    public fileOver(fileIsOver: boolean): void {
        this.fileIsOver = fileIsOver;
    }

    public onFileDrop(file, itemName): void {
        if(file.indexOf('data:application/pdf') == -1) {
            toastr.warning('You can only upload .pdf files');
            return;
        }
        if(this.step == '12')
            this.amenityTermsPdfSrc = file;
        else if(this.step == '19')
            this.parkingTermsPdfSrc = file;

        // if(file.dataTransfer.files && file.dataTransfer.files.length) {
        //     for(let i = 0; i < file.dataTransfer.files.length; i++) {
        //         this.addImage({target: { files: [file.dataTransfer.files[i]] } }, itemName);
        //     }
        // }
    }

    public onFileInput(file, itemName): void {
        if(!this.checkFile(file))
            return;
        file.preventDefault();
        const $img: any = document.querySelector('#fileInput');

        this.getBase64($img.files[0]);
        // if(file.target.files && file.target.files.length) {
        //     for(let i = 0; i < file.target.files.length; i++) {
        //         this.addImage({target: { files: [file.target.files[i]] } }, itemName);
        //     }
        // }
    }

    public getBase64(file): void {
        let self = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            if(self.step == '12')
                self.amenityTermsPdfSrc = reader.result;
            else if(self.step == '19')
                self.parkingTermsPdfSrc = reader.result;
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    clickFileInput() {
        document.getElementById('fileInput').click();
    }

    checkFile(e): boolean {
        const file = e.target.files[0];

        if (file.name.toLowerCase().indexOf('.pdf') === -1) {
            toastr.warning('You can only upload .pdf files');
            return false;
        }

        // if (file.size > 3000000) {
        //     toastr.warning('Maximum image size is 3MB.');
        //     return false;
        // }

        return true;
    }

    addImage(e, itemName) {
        const file = e.target.files[0];
        const fd = new FormData();
        // e.target.value = null;
        //
        // if (['.gif', 'jpeg', '.png', '.jpg', '.bmp'].indexOf(file.name.toLowerCase().slice(-4)) === -1) {
        //     toastr.warning('You can only upload images in .gif, .jpeg, .png, .jpg, .bmp formats');
        //     return;
        // }
        //
        // if (file.size > 3000000) {
        //     toastr.warning('Maximum image size is 3MB.');
        //     return;
        // }

        fd.append('fileUpload', file);
        fd.append('_format', 'json');

        // do something with fd
    }

    initSummernote(id) {
        const summernote = $(id);
        summernote.summernote({
            dialogsInBody: true,
            callbacks: { onChange: contents => {
                if(this.step == '12' && !this.selectedAmenity.useStandartTermsAndAgreement)
                    this.selectedAmenity.customTerms = contents;
                else if(this.step == '19')
                    this.parkingPassCustomTerms = contents;
            }},
            toolbar: [
                ['style', ['style']],
                ['fontsize', ['fontsize']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'hr']],
                ['help', ['help']]
            ],
            fontNames: ['Arial', 'open sans', 'Courier New'],
            disableDragAndDrop: true,
            disableResizeEditor: true,
            height: ($('.terms-wrapper').height() - 42 - 19 - 40)
        });
        $('.note-btn-bold').removeClass('active');
        $('.note-editable').html(this.step == '12' ? (this.selectedAmenity.useStandartTermsAndAgreement ? this.selectedAmenity.terms : this.selectedAmenity.customTerms) : (this.useStandartTermsAndAgreementForParkingPass ? this.parkingPassCustomTerms : this.parkingPassCustomTerms))
        .on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length)
                summernote.summernote('editor.saveRange');
        });
        if((this.step == '12' && this.selectedAmenity.useStandartTermsAndAgreement) ||
           (this.step == '19' && this.useStandartTermsAndAgreementForParkingPass))
            $('#summernote').summernote('disable');
    }

    showLegalAgreementEditPanelSetter(): void {
        setTimeout( () => this.initSummernote('#summernote'), 300);
    }

    choosePassRule(event) {
        if(this.parkingPassRules.find(r => r.name == event.source.name).checked) {
            if(event.source.name == '24') {
                this.parkingPassRules[0].checked = false;
                this.parkingPassRules[1].checked = false;
            } else
                this.parkingPassRules[2].checked = false;
        }
    }

    showPreviousPdfPage() {
        if(this.pdfPage > 1)
            this.pdfPage = this.pdfPage - 1;
    }

    showNextPdfPage() {
        if(this.pdfPage < this.currentPdfMaxPage)
            this.pdfPage = this.pdfPage + 1;
    }

    setupBuildingServicesWithEnteredInfo() {
        this.previousButtonIsDisabled = true;
        this.nextButtonIsDisabled = true;
        this.step = 'spinner1';
        const currentUser = JSON.parse(localStorage.getItem('userData'));
        const userRoles = this.userRoles.filter(role => currentUser.userRoles.indexOf(role.id) != -1)
                                        .map(role => ({bdId: role.id, roleName: role.name}));
        let observables = [];
        if(this.managementServices[4].checked)
            //setup amenities
            this.createAmenities(userRoles, observables);
        if(this.managementServices[5].checked)
            //setup parking
            this.createParking(userRoles, observables);
        if(this.securityServices[0].checked)
            //setup parcels
            this.createParcelSettings(observables);

        const chosenServices = this.managementServices.filter(s => s.checked)
                                                      .concat(this.securityServices.filter(s => s.checked))
                                                      .map(service => (service.name));
        if(this.serviceUpdateId)
            observables.push(this.updateBuildingServices({serviceIdentifier: chosenServices}));
        else
            observables.push(this.createBuildingServices({buildingId: this.selectedBuildingId, serviceIdentifier: chosenServices}));

        if(observables.length > 0) {
            Observable.forkJoin(observables).subscribe(
                response => {
                    //success
                    this.router.navigateByUrl('/property');
                }, error => {
                    //error
                    if(error.url.indexOf('amenity') != -1)
                        this.api.errorHandler(error, 'An error appeared during your amenities creation.');
                    if(error.url.indexOf('parking-pass') != -1)
                        this.api.errorHandler(error, 'An error appeared during your parking creation.');
                    if(error.url.indexOf('parcels') != -1)
                        this.api.errorHandler(error, 'An error appeared during your parcels settings creation.');
                    if(error.url.indexOf('auth') != -1)
                        this.api.errorHandler(error, 'An error appeared during your services setting.');
                    this.router.navigateByUrl('/property');
                    // this.step = '1';
                    // this.previousButtonIsDisabled = false;
                    // this.nextButtonIsDisabled = false;
                }
            );
        }
    }

    setProgressBarState() {
        if(this.managementServices[4].checked) {
            if(this.managementServices[5].checked) {

            } else if(this.securityServices[0].checked) {

            } else {
                if(this.step == '2')
                    this.currentProgress = 50;
            }
        } else if(this.managementServices[5].checked) {
            if(this.managementServices[4].checked) {

            } else if(this.securityServices[0].checked) {

            } else {
                if(this.step == '14')
                    this.currentProgress = 50;
            }
        } else if(this.securityServices[0].checked) {
            if(this.managementServices[4].checked) {

            } else if(this.managementServices[5].checked) {

            } else {
                if(this.step == '21')
                    this.currentProgress = 50;
            }
        } else {
            if(this.step == '26')
                this.currentProgress = 100;
        }
    }

    callBackFn(event) {
        this.currentPdfMaxPage = event.pdfInfo.numPages;
    }

    convertWeekDaysTimes(type, timings): any {
        let formattedArray = [
            { dayNumber: 1}, { dayNumber: 2}, { dayNumber: 3},
            { dayNumber: 4}, { dayNumber: 5}, { dayNumber: 6}, { dayNumber: 7}
        ];
        if(type == 'hourly' || type == 'range') {
            let minMaxArray = [];
            for (let i = 0; i < timings.length; i++) {
                minMaxArray.push({
                    minHour: timings[i].from,
                    maxHour: timings[i].to
                });
            }
            formattedArray = formattedArray.map(day => ({
                dayNumber: day.dayNumber,
                dayHours: minMaxArray
            }));
        }
        return formattedArray;
    }

    isEndHourDisabled(end, start): boolean {
        let disableOption = false;
        if (new Date(`01/01/1970 ${end}`) <= new Date(`01/01/1970 ${start}`))
            disableOption = true;
        return disableOption;
    }

    formatBuildingsForAmenity() {
        return this.buildingsList.filter(b => this.selectedBuilding.corporationNumber.id == b.corporationNumber).map((b) => ({
            buildingId: +b.id,
            buildingName: b.name
        }));
    }

    getUserRoles() {
        const url = '/api/v1/role.json?per-page=1000';
        this.api.get('oauthUrl', url).subscribe(
            res => {
                this.userRoles = [];
                const body = JSON.parse(res._body);
                this.userRoles = body.entities;
            },
            error => this.api.errorHandler(error, 'Failed get Roles')
        );
    }

    createAmenities(userRoles, observables) {
        this.amenitiesList.filter(amenity => amenity.checked).forEach(amenity => {
            let data: any = {
                name: amenity.displayName,
                buildingAmenity: this.formatBuildingsForAmenity(),
                allowResidentsToBook: 1,
                requiresManagerApproval: 1,
                confirmationMessage: amenity.agreement,
                legalAgreement: (amenity.useStandartTermsAndAgreement ? amenity.terms : amenity.customTerms) ? (amenity.useStandartTermsAndAgreement ? amenity.terms : amenity.customTerms) : undefined,
                legalAgreementStatus: (amenity.useStandartTermsAndAgreement ? amenity.terms : amenity.customTerms) ? 1 : 0,
                amenityImage: '../../assets/img/amenity-icons-svg/' + amenity.image,
                multipleBooking: 0,
                enableStatus: amenity.bookable ? 1 : 0,
                amenityColor: '#1ab394',
                timeSequenceType: amenity.bookable ? (amenity.name != '4' ? 'hourly' : 'daily') : undefined,
                uses: amenity.name != '3' ? [] : ['Move In', 'Move Out', 'Delivery'],
                paymentAcceptCheques: amenity.paymentDetails.acceptedPayments.cheque ? 1 : 0,
                paymentAcceptCreditCards: amenity.paymentDetails.acceptedPayments.creditCard ? 1 : 0,
                defaultPaymentMethod: amenity.paymentDetails.acceptedPayments.cheque ? 'cheque' : 'credit_card',
                maxTimeForAdvancedBooking: amenity.advancedBooking.limited && amenity.advancedBooking.number !== null ? (amenity.advancedBooking.number + ' ' + amenity.advancedBooking.period) : undefined,
                fees: amenity.paymentDetails.hasPayments ?
                      amenity.paymentDetails.payments.map(payment =>
                                                                           ({active: payment.active,
                                                                               required: payment.required,
                                                                               name: payment.name,
                                                                               amount: payment.amount,
                                                                               refundable: payment.refundable,
                                                                               pmtAtTime: payment.pmtAtTime
                                                                           })
                                                                       ) :
                      undefined,
            };
            if(amenity.bookable) {
                if (data.timeSequenceType == 'daily') {
                    data.dailyRule = {
                        bookingMinDay: 1,
                        bookingMaxDay: 7,
                        checkInTime: amenity.timings[0].from,
                        checkOutTime: amenity.timings[0].to,
                        limitActivityBookingOrDays: 'booking',
                        weekDays: this.convertWeekDaysTimes(data.timeSequenceType, amenity.timings),
                        limitActivityCountBookingOrDays: amenity.limitations.limited && amenity.limitations.number !== null ? amenity.limitations.number : undefined,
                        limitActivityRangeValue: amenity.limitations.limited && amenity.limitations.number !== null ? 'month' : undefined,
                        minIntervalBetweenBooking: amenity.bookingDistance.required && amenity.bookingDistance.number !== null ? (amenity.bookingDistance.number + ' ' + amenity.bookingDistance.period) : undefined
                    };
                } else {
                    data.hourlyRule = {
                        bookingMinHour: amenity.timings.from,
                        bookingMaxHour: amenity.timings.to,
                        timeStep: 30,
                        limitActivityBookingOrHours: 'booking',
                        weekDays: this.convertWeekDaysTimes(data.timeSequenceType, amenity.timings),
                        limitActivityCountBookingOrHours: amenity.limitations.limited && amenity.limitations.number !== null ? amenity.limitations.number : undefined,
                        limitActivityRangeValue: amenity.limitations.limited && amenity.limitations.number !== null ? 'month' : undefined,
                        minIntervalBetweenBooking: amenity.bookingDistance.required && amenity.bookingDistance.number !== null ? (amenity.bookingDistance.number + ' ' + amenity.bookingDistance.period) : undefined
                    };
                }
            }
            observables.push(this.api.post('domainAmenities', '/v1/amenity.json', data));
        });
    }

    createParking(userRoles, observables) {
        const data: any = {
            name: this.selectedBuilding.corporationNumber.name + ' Main Lot',
            building: [{
                buildingId: +this.selectedBuilding.id,
                buildingName: this.selectedBuilding.name,
                timezone: this.selectedBuilding.timeZone ? this.selectedBuilding.timeZone.value : undefined,
            }],
            enableStatus: 1
        };
        if(this.requireVisitorsToRegister && this.parkingPassRules.filter( rule => rule.checked).length > 0) {
            observables.push(this.api.post('domainParkingPass', '/v1/parking_lot.json', data).pipe(concatMap(
                res => {
                    let ruleData = {
                        name: 'Main Rule',
                        type: this.parkingPassRules[2].checked ? 'sliding' : 'general',
                        allowResidentsToBook: 1,
                        lotRule: [{parkingLot: res.id}],
                        enableStatus: 1,
                        disclaimer: this.parkingPassCustomTerms,
                        disclaimerStatus: this.parkingPassCustomTerms ? 1 : 0,
                        passTypes: []
                    };
                    if (this.parkingPassRules[2].checked) {
                        ruleData.passTypes.push({
                            allowSelfPrintingByResidents: 1,
                            doNotAllowResidentsPlates: 1,
                            maxPerSuiteCount: '1',
                            maxPerSuiteSequenceType: 'month',
                            name: '24 Hour Pass',
                            passTypeScheduleSliding: {
                                slidingPeriodCount: '24',
                                slidingSequenceType: 'hour'
                            },
                            printSuiteOnParkingPass: 1,
                            enableStatus: 1
                        });
                    }
                    if (this.parkingPassRules[0].checked) {
                        ruleData.passTypes.push({
                            allowSelfPrintingByResidents: 1,
                            doNotAllowResidentsPlates: 1,
                            maxPerSuiteCount: this.parkingPassLimitations.limited && this.parkingPassLimitations.number !== null ? this.parkingPassLimitations.number : undefined,
                            maxPerSuiteSequenceType: this.parkingPassLimitations.limited && this.parkingPassLimitations.number !== null ? 'month' : undefined,
                            name: 'Day Pass',
                            passTypeSchedule: {
                                endTime: this.parkingPassRules[0].to,
                                repeatable: 1,
                                scheduleDays: [{dayNumber: 1}, {dayNumber: 2}, {dayNumber: 3},
                                    {dayNumber: 4}, {dayNumber: 5}, {dayNumber: 6}, {dayNumber: 7}],
                                startTime: this.parkingPassRules[0].from
                            },
                            printSuiteOnParkingPass: 1,
                            enableStatus: 1
                        });
                    }
                    if (this.parkingPassRules[1].checked) {
                        ruleData.passTypes.push({
                            allowSelfPrintingByResidents: 1,
                            doNotAllowResidentsPlates: 1,
                            maxPerSuiteCount: this.parkingPassLimitations.limited ? this.parkingPassLimitations.number : undefined,
                            maxPerSuiteSequenceType: this.parkingPassLimitations.limited ? 'month' : undefined,
                            name: 'Night Pass',
                            passTypeSchedule: {
                                endTime: this.parkingPassRules[1].to,
                                repeatable: 1,
                                scheduleDays: [{dayNumber: 1}, {dayNumber: 2}, {dayNumber: 3},
                                    {dayNumber: 4}, {dayNumber: 5}, {dayNumber: 6}, {dayNumber: 7}],
                                startTime: this.parkingPassRules[1].from
                            },
                            printSuiteOnParkingPass: 1,
                            enableStatus: 1
                        });
                    }
                    return this.api.post('domainParkingPass', '/v1/parking_rule.json', ruleData);
                }, err => {

                }
            )));
        } else
            observables.push(this.api.post('domainParkingPass', '/v1/parking_lot.json', data));
    }

    createParcelSettings(observables) {
        const data = {
            useBarcodeScannerStatus: this.useBarCodeScanner ? 1 : 0,
            useSignaturePadStatus: this.useSignaturePad ? 1 : 0
        };
        const url = `/v1/parcel-service-settings/${this.selectedBuilding.corporationNumber.id}.json`;
        observables.push(this.api.patch('domainParcels', url, data));
    }

    getBuildingServices() {
        const queryParams = `buildingId=${this.selectedBuildingId}`;
        const url = `/api/v1/building_service.json?${queryParams}`;

        this.api.getJson('oauthUrl', url).subscribe(
          result => {
                if(result.entities[0]) {
                    this.serviceUpdateId = result.entities[0].id;
                    this.managementServices.forEach(service => {
                        service.checked = result.entities[0].serviceIdentifier.indexOf(service.name) != -1;
                    });
                    this.securityServices.forEach(service => {
                        service.checked = result.entities[0].serviceIdentifier.indexOf(service.name) != -1;
                    });
                }
            },
            error => this.api.errorHandler(error, 'Failed get Building Services')
        );
    }

    enableAllServices(): void {
        this.managementServices.forEach(s => s.checked = true);
        this.securityServices.forEach(s => s.checked = true);
    }

    getBuildingInfo() {
        const url = `/v1/buildings/${this.selectedBuildingId}.json?expand=contacts,corporationNumber,timeZone`;
        this.api.get('domainBD', url).subscribe(
            res => {
                const body = JSON.parse(res._body);
                this.selectedBuilding = body;
            },
            error => this.api.errorHandler(error, 'Failed get Building info')
        );
    }

    getBuildings() {
        this.buildingsList = [];
        const url = `/v1/buildings/short.json?order-by=name|asc`;
        this.api.getInfiniteList('domainBD', url, 30).subscribe(
            res => {
                this.buildingsList = [];
                this.buildingsList = res.entities;
            },
            error => this.api.errorHandler(error, 'Failed get Services')
        );
    }

    createBuildingServices(data: any) {
        return this.api.post('oauthUrl', `/api/v1/building_service.json`, data);
    }

    updateBuildingServices(data: any) {
        return this.api.patch('oauthUrl', `/api/v1/building_service/${this.serviceUpdateId}.json`, data);
    }

    onAmenityTimeChange(timeSlot, property) {
        if(this.selectedAmenity.name != '4') {
            if(property == 'from')
                timeSlot.to = '';
        } else {
            if(property == 'to')
                timeSlot.from = '';
        }
    }

    timingsOverlap(): boolean {
        let overlap = false;
        this.selectedAmenity.timings.forEach((timing, index) => {
            for (let i = 0; i < this.selectedAmenity.timings.length; i++) {
                if (i != index) {
                    if((new Date(`01/01/1970 ${timing.from}`) > new Date(`01/01/1970 ${this.selectedAmenity.timings[i].from}`) &&
                       new Date(`01/01/1970 ${timing.from}`) < new Date(`01/01/1970 ${this.selectedAmenity.timings[i].to}`)) ||
                       (new Date(`01/01/1970 ${timing.to}`) > new Date(`01/01/1970 ${this.selectedAmenity.timings[i].from}`) &&
                       new Date(`01/01/1970 ${timing.to}`) < new Date(`01/01/1970 ${this.selectedAmenity.timings[i].to}`)))
                        overlap = true;
                }
            }
        });
        return overlap;
    }

    public validateValue(event) {
        return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46;
    }

    allAmenitiesAreCompleted(): boolean {
        if(this.managementServices[4].checked)
            return this.amenitiesList.filter(amenity => amenity.setupCompleted).length >= this.amenitiesList.filter(amenity => amenity.checked && amenity.bookable).length;
        else
            return true;
    }

    timingDetailsAreValid(): boolean {
        return this.selectedAmenity.timings.filter(timing => timing.from && timing.to).length == this.selectedAmenity.timings.length;
    }

    onChargePeriodChange(event, payment) {
        if(event.source.value)
            payment.refundable = 0;
    }

    onRefundableChange(event, payment) {
        if(event.checked)
            payment.pmtAtTime = 0;
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        if(this.step == '12' || this.step == '19')
            $('.note-editable').height($('.terms-wrapper').height() - 42 - 19 - 70);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/building-setup/building-setup.component.ts